export const SERVICES = [
  "기업 홈페이지 제작",
  "웹 플랫폼 개발",
  "AI 솔루션 개발",
  "업무 자동화 구축",
  "기타 / 미정",
];

export const BUDGETS = [
  "100만원 이하",
  "100~300만원",
  "300~500만원",
  "500~1,000만원",
  "1,000만원 이상",
  "협의",
];

export const TIMELINES = [
  "최대한 빠르게",
  "1개월 이내",
  "3개월 이내",
  "6개월 이내",
  "협의",
];

export const YN = [
  { v: "", l: "선택" },
  { v: "true", l: "예" },
  { v: "false", l: "아니오" },
];

export const initialContactForm = {
  name: "",
  email: "",
  phone: "",
  company: "",
  service_type: SERVICES[0],
  project_purpose: "",
  requirements: "",
  has_domain: "",
  has_hosting: "",
  has_existing_site: "",
  existing_site_url: "",
  budget: BUDGETS[0],
  timeline: TIMELINES[0],
  message: "",
};

/** 로그인 고객 프로필을 문의 양식 기본값에 연결 */
export function withCustomerContactDefaults(form, profile) {
  if (!profile?.email) return form;
  return {
    ...form,
    name: profile.name || form.name,
    email: profile.email || "",
    phone: profile.phone || "",
    company: profile.company || form.company,
  };
}
